// Agregar un interceptor para incluir el token de autenticación en las solicitudes
import apiClient from "@/api/axios";

// Agregar un interceptor para incluir el token de autenticación en las solicitudes
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * Obtener la lista de usuarios
 * @returns {Promise<Array>} Lista de usuarios
 */
export const getRides = async (status) => {
    try {
        const response = await apiClient.get(`/admin/rides/${status}`);
        return response.data; // Asumiendo que la API devuelve los usuarios en la propiedad 'data'
    } catch (error) {
        console.error('Error al obtener los usuarios:', error);
        throw error;
    }
};

/**
 * Obtener la lista de usuarios
 * @returns {Promise<Array>} Lista de usuarios
 */
export const getUserRides = async (status, page, limit) => {
    try {
        const response = await apiClient.get(`/rides/user/${status}`,{params: {page, limit}});
        return response.data;
    } catch (error) {
        console.error('Error al obtener los usuarios:', error);
        throw error;
    }
};

// Delete trip
export const deleteRide = async (tripId) => {
    // try {
    //     const response = await apiClient.delete(`/admin/rides/${tripId}`);
    //     return response.data;
    // } catch (error) {
    //     console.error('Error al eliminar el viaje:', error);
    //     throw error;
    // }
    console.log('Trip deleted:', tripId);
};

// Accept ride
export const acceptRide = async (rideId, driverId) => {
    try {
        const response = await apiClient.post(`/rides/${rideId}/accept`, { driverId: driverId});
        return response.data;
    } catch (error) {
        console.error('Error al aceptar el viaje:', error);
        throw error;
    }
}

// Cancel ride
export const cancelRide = async (rideId) => {
    try {
        const response = await apiClient.put(`/rides/${rideId}/cancel`);
        return response.data;
    } catch (error) {
        console.error('Error al cancelar el viaje:', error);
        throw error;
    }
}

// Create trip
export const createRide = async (rideData) => {
    try {
        const response = await apiClient.post('/rides', rideData);
        return response.data;
    } catch (error) {
        console.error('Error al crear el viaje:', error);
        throw error;
    }
};

// Ride details
export const getRideDetails = async (rideId) => {
    try {
        const response = await apiClient.get(`/rides/${rideId}`);
        return response.data;
    } catch (error) {
        console.error('Error al obtener los detalles del viaje:', error);
        throw error;
    }
};